import { tool } from '@strands-agents/sdk'
import { z } from 'zod'

export const openPanelTool = tool({
  name: 'open_panel',
  description: 'Open a UI panel (camera/peers/qr/settings) by dispatching custom event',
  inputSchema: z.object({ panel: z.enum(['camera', 'peers', 'qr', 'settings']) }),
  callback: (input) => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(`careless:${input.panel}-open`))
    }
    return JSON.stringify({ status: 'opened', panel: input.panel })
  },
})

export const closePanelTool = tool({
  name: 'close_panel',
  description: 'Close a UI panel',
  inputSchema: z.object({ panel: z.enum(['camera', 'peers', 'qr', 'settings']) }),
  callback: (input) => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(`careless:${input.panel}-close`))
    }
    return JSON.stringify({ status: 'closed', panel: input.panel })
  },
})

export const PANEL_TOOLS = [openPanelTool, closePanelTool]
